import axios from "axios";
// import * as firebase from "firebase/app";
import "firebase/auth";
import { User } from "@/models/user";
// import { AuthData } from "@/models/auth";
// import Cellar from "@/models/cellar";
// @ts-ignore
// import { JsonApiDataStore } from "../../../node_modules/jsonapi-datastore";
import { AuthRequests, configService } from "../index";

export function fetchUserDetails(
  token?: string,
  data?: Object,
  authMode?: string
): Promise<any> {
  const buildUserDetailsPromise = () =>
    axios.get(
      configService.profile,
      token ? { headers: { Authorization: `Bearer ${token}` } } : undefined
    );
  return buildUserDetailsPromise()
    .then(
      (response: any): User => {
        const item = response.data;
        return new User().deserialize(item);
      }
    )
    .catch((error: any) => {
      throw error;
    });
}

export function signUp(email: string, password: string, firstName: string, lastName: string, passwordConfirmation: string) {
  return axios
    .post(`${configService.authService}/registrations`, { account: { email: email, password: password, first_name: firstName, last_name: lastName, password_confirmation: passwordConfirmation }})
    .then((response: any): any => {
      localStorage.setItem("userToken", response.headers.authorization.split(" ")[1]);
      localStorage.setItem("expiration", response.data.expires_at);
      localStorage.setItem("userName", response.data.account.first_name);
      localStorage.setItem("userLastName", response.data.account.last_name);
      localStorage.setItem("type", response.data.account.role);
    })
    .catch(err => {
      let msg;
      msg = (err.data.errors) ? `${Object.keys(err.data.errors)[0]} ${err.data.errors[Object.keys(err.data.errors)[0]][0]}` : "Some unknown error";
      throw new Error(msg);
    });
}

export function signIn(email: string, password: string): any {
  return axios
    .post(`${configService.authService}/tokens`, { email: email, password: password })
    .then((response: any): any => {
      localStorage.setItem("userToken", response.headers.authorization.split(" ")[1]);
      localStorage.setItem("expiration", response.data.expires_at);
      localStorage.setItem("userName", response.data.account.first_name);
      localStorage.setItem("userLastName", response.data.account.last_name);
      localStorage.setItem("type", response.data.account.role);
    })
    .catch(err => {
      // localStorage.removeItem("userToken");
      // localStorage.removeItem("userName");
      // localStorage.removeItem("userLastName");
      // localStorage.removeItem("expiration");
      // localStorage.removeItem("type");
      signOut();
    });
}

//TODO: make a User interface
export function signInSocial(provider: string, token: string, user: any) {
    return axios
        .post(
            `${configService.authService}/tokens/${provider}`,
            {token: token, account: {email: user.email, first_name: user.firstName, last_name: user.lastName}}
        )
        .then((response: any): any => {
            console.log(response);
            localStorage.setItem("userToken", response.headers.authorization.split(" ")[1]);
            localStorage.setItem("expiration", response.data.expires_at);
            localStorage.setItem("userName", response.data.account.first_name);
            localStorage.setItem("userLastName", response.data.account.last_name);
        })
        .catch(err => {
            // localStorage.removeItem("userToken");
          //             // localStorage.removeItem("userName");
          //             // localStorage.removeItem("userLastName");
          //             // localStorage.removeItem("expiration");
          //             // localStorage.removeItem("type");
          signOut();
        });
}

export function signOut(): any {
  localStorage.removeItem("userToken");
  localStorage.removeItem("userName");
  localStorage.removeItem("userLastName");
  localStorage.removeItem("expiration");
  localStorage.removeItem("type");
}

export function autoAuthUser() {
  const authInfo = getAuthData();
  if (!authInfo) {
    return null;
  }
  const now = new Date();
  const expiresIn = authInfo.expirationDate ? authInfo.expirationDate.getTime() - now.getTime() : 0;
  if (expiresIn > 0) {
    return authInfo;
  } else {
    return null;
  }
}

export function resetPassword(options: any) {
  return axios
    .post(`${configService.authService}/password`, { account: { email: options.email } })
    .then((response) => {
      return true;
    })
    .catch(err => {
      console.error(err);
      return false;
    });
}

export function changePassword(options: any) {
  return axios
    .put(`${configService.authService}/password`, { account: { password: options.password, password_confirmation: options.password, reset_password_token: options.token } })
    .then((response) => {
      return true;
    })
    .catch(err => {
      throw new Error(err);
    });
}

function getAuthData() {
  const token = localStorage.getItem("userToken");
  const userName = localStorage.getItem("userName");
  const userLastName = localStorage.getItem("userLastName");
  const expirationDate = localStorage.getItem("expiration");
  const role = localStorage.getItem("type");
  if (!token && !expirationDate) {
    return null;
  }
  return {
    token: token,
    userName: userName,
    userLastName: userLastName,
    expirationDate: expirationDate ? new Date(expirationDate) : null,
    type: role
  };
}
